import call from "./call";
import {getAuthDataFromState} from "../utils";

const getReportPreview= (reportName,reportValues,onResult) => async (dispatch,getState) =>
{
    const data=getAuthDataFromState(dispatch,getState);
    if(!data)
        return;

    const handleResult= (result) => {
        if(onResult)
            onResult(result.report,result);
    };

    dispatch(call("Service/" + reportName, {...data,reportValues},handleResult));
};
export default getReportPreview;
